import styled from "styled-components";
import BadgeVariant from "../../../styles/atoms/Badge.styles";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-1);

    @supports not (row-gap: var(--spacing-1)) {
        ${BadgeVariant} {
            &:not(:nth-last-child(1)) {
                margin-bottom: var(--spacing-1);
            }
        }
    }
`;
